import {
  ApolloClient,
  ApolloLink,
  concat,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import fetch from 'cross-fetch';

import { configValues } from 'src/config';

export const client = (
  getAuthToken: () => string | undefined,
  getXToken: () => string | undefined,
) => {
  const httpLink = createHttpLink({
    fetch,
    uri: `${configValues.GRAPHQL_API_URL}`,
  });

  const authMiddleware = new ApolloLink((operation, forward) => {
    const xToken = getXToken();
    const authToken = getAuthToken();

    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...(xToken && { 'x-token': xToken }),
      },
    }));

    return forward(operation);
  });

  return new ApolloClient({
    link: concat(authMiddleware, httpLink),
    // The typename is used to form the primary key in Apollo's normalized datastore
    // https://www.apollographql.com/docs/react/caching/cache-configuration/#addtypename
    cache: new InMemoryCache({ addTypename: true }),
  });
};
